import React, { useRef, useEffect } from "react";

const CollapsibleSection = ({
  title,
  isExpanded,
  isValid,
  onToggle,
  children,
  sectionNumber,
}) => {
  const sectionRef = useRef(null);
  const wasExpanded = useRef(isExpanded);

  useEffect(() => {
    // Scroll to top of section when it opens (but not on initial render)
    if (isExpanded && !wasExpanded.current && sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    wasExpanded.current = isExpanded;
  }, [isExpanded]);

  const headerClass = isExpanded
    ? "isp-section-header expanded"
    : isValid
    ? "isp-section-header collapsed valid"
    : "isp-section-header collapsed";

  const numberClass = isExpanded
    ? "isp-section-number expanded"
    : isValid
    ? "isp-section-number valid"
    : "isp-section-number default";

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onToggle();
    }
  };

  return (
    <div className="isp-section" ref={sectionRef}>
      <div
        className={headerClass}
        onClick={onToggle}
        onKeyDown={handleKeyDown}
        tabIndex="0"
        role="button"
        aria-expanded={isExpanded}
        aria-label={`${title} section${isValid ? " (complete)" : ""}`}
      >
        <div className="isp-section-header-left">
          {sectionNumber && (
            <span className={numberClass} aria-hidden="true">
              {isValid ? "\u2713" : sectionNumber}
            </span>
          )}
          <span className="isp-section-header-title">{title}</span>
        </div>
        <span
          className={`isp-section-chevron${isExpanded ? " expanded" : ""}`}
          aria-hidden="true"
        >
          &#9660;
        </span>
      </div>
      {isExpanded && <div className="isp-section-body">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
